<div class="info-page__section">
  <div class="info-page__block">
    <ng-content select="[info-page-overwrite]"></ng-content>
    @if (
      title ||
      description ||
      inputFields ||
      inputLinkButton ||
      inputSubmitButton ||
      footerContent
    ) {
      <app-info-content
        [title]="title"
        [description]="description"
        [inputFields]="inputFields"
        [footerContent]="footerContent"
        [inputLinkButton]="inputLinkButton"
        [inputSubmitButton]="inputSubmitButton"
        [submitForm]="submitForm"
      >
      </app-info-content>
    }
    @if (script != null) {
      <script>
        script;
      </script>
    }
  </div>
</div>
